import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';


@Component({
  selector: 'app-side-options-mobile',
  templateUrl: './side-options-mobile.component.html',
  styleUrls: ['./side-options-mobile.component.css']
})
export class SideOptionsMobileComponent implements OnInit {

  @Input() caducityTime!: Date;
  @Output('onClickShare') onClickShareEmitter = new EventEmitter<void>();
  @Output('onClickRenew') onClickRenewEmitter = new EventEmitter<void>();
  
  opened: boolean = false;

  constructor(
    
  ) { }

  ngOnInit(): void {
  }

  open() {
    console.log('clicked');
    this.opened = true;
  }

  close() {
    this.opened = false;
  }

  toggleCollapse() {
    this.opened = !this.opened;
  }

  onClickShare() {
    this.onClickShareEmitter.emit();
  }
  onClickRenew() {
    this.onClickRenewEmitter.emit();
  }
  onClickDownload() {
  }

  onClickSeeStudy() {
    let visorWindow = window.open('https://demoportal.m3meuropa.com:8003/visor?sid=2.25.202937750069726115330238499369632433045', 'Visor', 'toolbar=no,top=10,left=10,width=' + (screen.width - 50) + ',height=' + (screen.height - 100));
  }

}
